(function ($) {

  var acc = document.getElementsByClassName("store-switcher-accordion");
  var i;

  const body = $("body");
  const toggle = $(".store-switcher");
  const popup = $(".store-switcher-popup");
  const popupOverlay = $(".store-switcher-popup-overlay");
  const popupExitButton = $(".store-switcher-exit-button");

  // Country selection is handled by Shopify's localization form inside the popup
  // (snippets/store-switcher-markets-popup.liquid); this file only manages the
  // popup open/close state and the region accordions.

  toggle.on("click", function (e) {
    e.preventDefault();
    popup.addClass('open');
    popupOverlay.addClass('open');
    body.addClass('stop-scroll');
  });

  function closePopup() {
    popup.removeClass('open');
    body.removeClass('stop-scroll');
    popupOverlay.removeClass('open');
    setTimeout(function () {
      for (i = 0; i < acc.length; i++) {
        acc[i].classList.remove("active");
        var panel = acc[i].nextElementSibling;
        panel.style.maxHeight = null;
      }
    }, 200);
  }

  popupOverlay.on("click", function () {
    closePopup();
  });

  popupExitButton.on("click", function () {
    closePopup();
  });

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }

})(jQuery);
